import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { IResultsState } from '@results/store/index';
import { selectRouterQueryParams } from '@store/router/router.selector';

export const selectResultsState = createFeatureSelector<IResultsState>('results');
export const selectResults = createSelector(selectResultsState, (state) => {
  return state !== undefined ? state.results : null;
});

export const selectError = createSelector(selectResults, (state) => state?.error);
export const selectPagination = createSelector(selectResults, (state) => state?.pagination);
export const selectHotels = createSelector(selectResults, (state) => state?.hotels);
export const selectCustomBanner = createSelector(selectResults, (state) => state.customBanner);
export const selectRecommendedHotels = createSelector(
  selectResults,
  (state) => state.recommendedHotels,
);
export const selectAllLocations = createSelector(selectResults, (state) => state.locationData);
export const selectFilters = createSelector(selectResults, (state) => state.filters);

export const selectFiltersList = createSelector(selectFilters, (state) => state.list);
export const selectFiltersApplied = createSelector(selectFilters, (state) => state.applied);

export const selectLoading = createSelector(selectResults, (state) => {
  return state?.loading;
});

export const selectViewMap = createSelector(selectResults, (state) => {
  return state.viewMap;
});

export const selectDestination = createSelector(selectResults, (state) => {
  return state?.destination;
});

export const selectFilterQueryParams = createSelector(
  selectRouterQueryParams,
  selectFiltersApplied,
  (queryParams, applied) => {
    if (!applied || !queryParams) {
      return true;
    } else {
      const arrayQueryParams = Object.values(queryParams);
      return arrayQueryParams?.length >= applied?.length;
    }
  },
);
